// @flow
import actionTypes from '../actionTypes';
import { fetch } from '../../api';

export function fetchGroups() {
  return async function(dispatch: Dispatch, getState: GetState) {
    const { context } = getState();

    if (!context.isActive) {
      return;
    }

    try {
      const { payload } = await fetch(
        'communities',
        { query: { userID: context.userId } }
      );
      payload.groups.forEach(group => group.isFollowing = true);

      dispatch({
        type: actionTypes.DATA_FETCH_SUCCESS,
        data: { groups: payload.groups },
        isAsynchronous: true,
      });
    } catch (error) {
      dispatch({ type: actionTypes.DATA_FETCH_FAILURE, error, isAsynchronous: true });
    }
  };
}

export function fetchNotificationPreference(unsubscribeKey) {
  return async function(dispatch: Dispatch, getState: GetState) {
    const state = getState();
    const id = state.context.userId;
    const query = unsubscribeKey ? { unsubscribeKey } : { userId: id };
    try {
      const { payload } = await fetch('user-notification-preference', { query });
      const notificationPreference = payload.userNotificationPreference.notificationPreference;

      dispatch({
        type: actionTypes.DATA_FETCH_SUCCESS,
        data: { users: { [id]: { notificationPreference } } },
        bypassMiddleware: true,
      });
    } catch (error) {
      dispatch({ type: actionTypes.DATA_FETCH_FAILURE, error });
    }
  };
}

export function updateProfile(update: any, url: string = 'profile/about', UnsubscribeKey) {
  return async function(dispatch: Dispatch, getState: GetState) {
    const state = getState();
    const id = state.context.userId;
    const currentUser = state.data.users[id];

    const safe = {};
    Object.keys(update).forEach(key => safe[key] = currentUser[key]);

    dispatch({
      type: actionTypes.PROFILE_UPDATE,
      data: { users: [{ id, ...update }] },
    });

    try {
      const body = JSON.stringify({ ...update, UserId: id, UnsubscribeKey});

      await fetch(url, { method: 'PUT', body });
      dispatch({
        type: actionTypes.PROFILE_UPDATE_SUCCESS,
        alert: {
          type: actionTypes.PROFILE_UPDATE_SUCCESS,
          alertType: 'success',
        },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.PROFILE_UPDATE_FAILURE,
        data: { users: { [id]: safe } },
        bypassMiddleware: true,
        error,
        alert: {
          type: actionTypes.PROFILE_UPDATE_FAILURE,
        },
      });
    }
  };
}

export function updatePassword(currentPassword: string, newPassword: string) {
  return async function(dispatch: Dispatch, getState: GetState) {
    dispatch({ type: actionTypes.PROFILE_UPDATE });

    try {
      const state = getState();
      const userId = state.context.userId;
      const body = JSON.stringify({ currentPassword, newPassword, userId });

      await fetch('account/password', { method: 'PUT', body });
      dispatch({ type: actionTypes.PROFILE_UPDATE_SUCCESS,
        alert: {
          type: actionTypes.PROFILE_UPDATE_SUCCESS,
          alertType: 'success',
        },
      });
    } catch (error) {
      const type = actionTypes.PROFILE_UPDATE_FAILURE;
      dispatch({ type, alert: { type } });
    }
  };
}

export function resendVerificationEmail() {
  return async function(dispatch: Dispatch) {
    dispatch({ type: actionTypes.PROFILE_UPDATE });

    try {
      await fetch('profile/resend-verification-link', { method: 'POST' });
      dispatch({ type: actionTypes.PROFILE_UPDATE_SUCCESS });
    } catch (error) {
      const type = actionTypes.PROFILE_UPDATE_FAILURE;
      dispatch({ type, alert: { type } });
    }
  };
}

export function unsubscribe() {
  return async function(dispatch: Dispatch, getState: GetState) {
    const state = getState();
    const id = state.context.userId;
    dispatch({ type: actionTypes.PROFILE_UNSUBSCRIBE });
    let type;

    try {
      const { payload } = await fetch('user-notification-preference', { query: { userId: id } });
      const prefs = payload.userNotificationPreference.notificationPreference
        .map(pref => ({ ...pref, enabled: false }));

      dispatch(updateProfile({ notificationPreference: prefs }, 'user-notification-preference'));
      type = actionTypes.PROFILE_UNSUBSCRIBE_SUCCESS;
      dispatch({ type, alert: { type, alertType: 'general' } });
    } catch (error) {
      type = actionTypes.PROFILE_UNSUBSCRIBE_FAILURE;
      dispatch({ type, alert: { type } });
    }
  };
}

// Saves avatar after upload
export function cropAndSaveAvatar({ cropWidth, x = 0, y = 0 }) {
  return async function(dispatch: Dispatch, getState: GetState) {
    dispatch({ type: actionTypes.PROFILE_AVATAR_UPDATE });

    try {
      const state = getState();
      const userId = state.context.userId;
      const body = JSON.stringify({ userId, X: x, Y: y, width: cropWidth });
      const { payload } = await fetch('profile/picture', { method: 'PUT', body });
      const userData = payload.pictureResponse;
      dispatch({
        type: actionTypes.PROFILE_AVATAR_UPDATE_SUCCESS,
        data: { users: [{ id: userId, ...userData }] },
      });
    } catch (error) {
      const type = actionTypes.PROFILE_AVATAR_UPDATE_FAILURE;
      dispatch({ type, alert: { type } });
    }
  };
}

export function deleteAccount(reason?: String) {
  return async function(dispatch: Dispatch, getState: GetState) {
    const state = getState();
    const id = state.context.userId;
    const currentUser = state.data.users[id];

    dispatch({ type: actionTypes.PROFILE_DELETE });

    const data = {
      username: currentUser.username,
      ReasonDeleted: reason || undefined,
    };

    try {
      await fetch('profile', { method: 'DELETE', body: JSON.stringify(data) });
      const type = actionTypes.PROFILE_DELETE_SUCCESS;
      dispatch({ type, alert: { type, alertType: 'success' } });
    } catch (error) {
      const type = actionTypes.PROFILE_DELETE_FAILURE;
      dispatch({ type, state, alert: { type } });
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/userFlowActionsCreator/general.js